import React, {Component} from 'react';
import Navs from "../../components/Navs/Navs";
import Footer from "../../components/Footer/Footer";
import "./About.scss"
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic"
/* tab */
import AboutBrief from "../../components/AboutBrief/AboutBrief";
import AboutHonor from "../../components/AboutHonor/AboutHonor";
import AboutSketch from "../../components/AboutSketch/AboutSketch";

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                list: ["公司简介", "荣誉资质", "平台简述"],
                index: 0,
            },
            qrcode: "",
            picUrl: "",
        }
    }

    componentDidMount() {
        this.getAboutData();
    }

    getAboutData() {
        this.$axios.apiList.getAboutData({})
            .then(res => {
                this.setState({
                    qrcode: res.data.qrcode,
                    picUrl: res.data.picUrl,
                })
            })
            .catch(error => {

            })
    }

    tabsClick(index) {
        let {tabs} = this.state;
        tabs.index = index;
        this.setState({});
    }

    render() {
        let {tabs,picUrl,qrcode} = this.state;
        return (
            <div className="about">
                <div className="navs">
                    <Navs fullPageIndex={6}></Navs>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <ComTitle {...titleObj.about}></ComTitle>
                <div className="content">
                    <div className="content-tabs">
                        {
                            tabs.list.map((item, index) => {
                                return (
                                    <div className={`item${index === tabs.index ? " in" : ""}`}
                                         onClick={this.tabsClick.bind(this, index)}
                                         key={index}>
                                        {item}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="content-list">
                        {
                            tabs.index === 0 && <AboutBrief></AboutBrief>
                        }
                        {
                            tabs.index === 1 && <AboutHonor></AboutHonor>
                        }
                        {
                            tabs.index === 2 && <AboutSketch qrcodeImg={qrcode}></AboutSketch>
                        }
                    </div>
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

export default About;
